module.exports = __webpack_public_path__ + "img/globe-03.68af9f76.svg";